import { STORAGE_KEYS } from './storageKeys';

class tokenClass {
  getTokenFromSession = () => {
    return sessionStorage.getItem(STORAGE_KEYS.TOKEN);
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new tokenClass();
